import React from 'react';
import AssetsbuyerContainer from './AssetsbuyerContainer';

const AssetsBuyerView = () => {
  return <AssetsbuyerContainer />;
};

export default AssetsBuyerView;
